import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('bringozPackagesCustomDataDisplay', bringozPackagesCustomDataDisplay);

function bringozPackagesCustomDataDisplay() {
  return function bringozPackagesCustomDataDisplayFilter(packageItems, packageDynamicColumn) {
    if (!packageItems) {
      packageItems = [];
    }
    let match = undefined;
    _.forEach(packageItems, (item) => {
      if (!!match) {
        return;
      }
      match = _.find(item.configuredFields || [], (cf) => {
        return cf.id === packageDynamicColumn.id || cf.packageFieldId === packageDynamicColumn.id || cf.fieldName === packageDynamicColumn.title;
      })
    })
    return match?.value || '---';
  }
}
